<div class="ft-tooltip-menu" *ngIf="isVisible">
    <ng-container [ngTemplateOutlet]="tooltip"></ng-container>
    <ng-content select="[tooltip]"></ng-content>
</div>
<div (click)="show(); $event.stopPropagation()">
    <ng-content select="[trigger]"></ng-content>
</div>